function text(value) {
  return String(value == null ? "" : value).trim();
}

export function normalizeVehicleFreightSenderRole(role) {
  return text(role).toUpperCase();
}

export function activeFreightsRequestForRole(role) {
  const normalizedRole = normalizeVehicleFreightSenderRole(role);
  if (normalizedRole === "DRIVER") {
    return {
      transport: "driver",
      path: "/api/driver/own-freights?state=ACTIVE&limit=100",
    };
  }

  if (["CARGO", "EXPEDITOR"].includes(normalizedRole)) {
    return {
      transport: "market",
      path: "/posts/mine?state=ACTIVE&limit=100",
    };
  }

  return null;
}
